import React from 'react'

const CLIENT_ID =
  'AZDxjDScFpQtjWTOUtWKbyN_bDt4OgqaF4eYXlewfBP4-8aqX3PiV8e1GWU6liB2CUXlkA59kJXE7M6R'
const HOST = 'https://www.sandbox.paypal.com'
const ENV = 'sandbox'

const fundingEligibility = btoa(
  JSON.stringify({
    paypal: { eligible: true, vaultable: false },
    paylater: {
      eligible: true,
      vaultable: false,
      products: {
        payIn3: { eligible: false, variant: null },
        payIn4: { eligible: false, variant: null },
        paylater: { eligible: true, variant: null },
      },
    },
    card: {
      eligible: true,
      branded: true,
      installments: false,
      vendors: {
        visa: { eligible: true, vaultable: true },
        mastercard: { eligible: true, vaultable: true },
        amex: { eligible: true, vaultable: true },
        discover: { eligible: true, vaultable: true },
        hiper: { eligible: false, vaultable: false },
        elo: { eligible: false, vaultable: true },
        jcb: { eligible: true, vaultable: true },
        maestro: { eligible: true, vaultable: true },
        diners: { eligible: true, vaultable: true },
        cup: { eligible: true, vaultable: true },
      },
      guestEnabled: false,
    },
    venmo: { eligible: false, vaultable: false },
    itau: { eligible: false },
    credit: { eligible: false },
    applepay: { eligible: false },
    sepa: { eligible: false },
    ideal: { eligible: false },
    bancontact: { eligible: false },
    giropay: { eligible: false },
    eps: { eligible: false },
    sofort: { eligible: false },
    mybank: { eligible: false },
    p24: { eligible: false },
    wechatpay: { eligible: false },
    payu: { eligible: false },
    blik: { eligible: false },
    trustly: { eligible: false },
    oxxo: { eligible: false },
    boleto: { eligible: false },
    boletobancario: { eligible: false },
    mercadopago: { eligible: false },
    multibanco: { eligible: false },
    satispay: { eligible: false },
    paidy: { eligible: false },
  }),
)

const sdkMeta = btoa(
  JSON.stringify({
    url: `${HOST}/sdk/js?client-id=${CLIENT_ID}&components=buttons`,
    attrs: { 'data-uid': 'uid_gwhtyobzcqksoqgismnvtnhvqejrfv' },
  }),
)

export const SmartButtonFrame: React.FC<Record<string, string>> = ({
  fundingSource,
  styleLayout,
  messageAmount,
  messageAlign,
  messageColor,
  messagePosition,
}) => {
  const params = {
    // Input params
    'style.layout': styleLayout,
    'message.amount': messageAmount,
    'message.align': messageAlign,
    'message.color': messageColor,
    'message.position': messagePosition,
    fundingSource,

    // Static params
    allowBillingPayments: 'true',
    applePaySupport: 'false',
    buttonSessionID: 'uid_2108755c13_mtm6mde6ntq',
    buttonSize: 'large',
    clientID: CLIENT_ID,
    clientMetadataID: 'uid_9d0a2e12d6_mti6nte6mju',
    commit: 'true',
    'components.0': 'buttons',
    currency: 'USD',
    debug: 'false',
    disableSetCookie: 'true',
    env: ENV,
    'experiment.enableVenmo': 'false',
    flow: 'purchase',
    fundingEligibility,
    intent: 'capture',
    'locale.country': 'US',
    'locale.lang': 'en',
    platform: 'desktop',
    sessionID: 'uid_9d0a2e12d6_mti6nte6mju',
    sdkCorrelationID: 'c7491e54eef05',
    sdkMeta,
    sdkVersion: '5.0.430',
    storageID: 'uid_0443cb7139_mtu6mzc6mzi',
    'style.color': 'gold',
    'style.shape': 'rect',
    'style.tagline': 'false',
    'style.menuPlacement': 'below',
    supportedNativeBrowser: 'false',
    supportsPopups: 'true',
    vault: 'false',
  }

  if (fundingSource) {
    params['renderedButtons.0'] = fundingSource
  } else if (styleLayout === 'horizontal') {
    params['renderedButtons.0'] = 'paypal'
    params['renderedButtons.1'] = 'paylater'
  } else {
    params['renderedButtons.0'] = 'paypal'
    params['renderedButtons.1'] = 'paylater'
    params['renderedButtons.2'] = 'card'
  }

  const filteredParams = Object.entries(params).filter(
    ([, val]) => typeof val !== 'undefined',
  )

  const url = `${HOST}/smart/buttons?${new URLSearchParams(
    filteredParams,
  ).toString()}`

  return (
    <div
      style={{
        borderRadius: '0.2rem',
        padding: '0.5rem',
        background: messageColor === 'white' ? '#555' : 'transparent',
      }}
    >
      <iframe
        src={url}
        style={{
          border: 'none',
          width: '400px',
          height: styleLayout === 'vertical' ? '270px' : '100px',
          display: 'block',
          margin: 'auto',
        }}
      />
    </div>
  )
}

export default SmartButtonFrame
